import { get, post } from '@/api/axios';
import { InvitationEndpoints } from '@/api/endpoints/InvitationEndpoints';
import { type InvitationValidationResponseDto } from '@/app/models/InvitationValidationResponseDto';

export const getInvitationValidation = (inviteId: string) => {
  return get<InvitationValidationResponseDto>(InvitationEndpoints.validate(inviteId));
};

export const acceptInvitation = (inviteId: string, body: object) => {
  return post(InvitationEndpoints.accept(inviteId), body);
};
